import { NgModule } from '@angular/core';
import {PdfViewerComponent} from './pdf-viewer.component';
import {PdfRoutingModule} from './pdf-viewer.routing.module';
import {CommonModule} from '@angular/common';
import {MytaxPdfViewerModule} from '@datev/mytax-pdf-viewer';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';

@NgModule({
  declarations: [PdfViewerComponent],
  imports: [PdfRoutingModule, CommonModule,NgxExtendedPdfViewerModule, MytaxPdfViewerModule],
  bootstrap: [PdfViewerComponent],
})

export class PdfViewerModule {}
